import { render } from "./HygienePaidBills.vue?vue&type=template&id=6b153049&scoped=true"
import script from "./HygienePaidBills.vue?vue&type=script&lang=js"
export * from "./HygienePaidBills.vue?vue&type=script&lang=js"

import "./HygienePaidBills.vue?vue&type=style&index=0&id=6b153049&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b153049"]])

export default __exports__